<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='""' class="container-fluid py-5" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="row mx-auto justify-content-center align-items-center" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="col-lg-6 text-right" >
                <template #default>   <m-h5 v-bind='{...{},...{}}' :style='"font-size: 13px;"' class="border-bottom my-3 pb-3 text-dark" >
                <template #default>فرم درخواست فروشنده   </template>
                </m-h5><m-form-single-1 v-bind='{...{"itemClass":"col-lg-12 mb-3","formId":5,"redirectToDashboard":false,"redirectDirectLink":"https:\/\/medicalmobile.ir\/submit-form"},...{}}' :style='""' class="mt-5" ></m-form-single-1></template>
                </m-div></template>
                </m-div></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mH5 from '@moeinmdn/miw-alpha-components/src/package/Tags/H5'; import mFormSingle1 from '@moeinmdn/miw-alpha-components/src/package/Form/FormSingle/FormSingle1';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mH5,mFormSingle1 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
